module.exports = __webpack_public_path__ + "media/banners/cta_background-eba731cb.png";